import { call, put, takeEvery } from "redux-saga/effects";

import { PaginateQuery, ResponseGenerator } from "../../interfaces";
import {
  ADD_SUBJECT_NOTE,
  AddSubjectNoteAction,
  DELETE_SUBJECT_NOTE,
  DeleteSubjectNoteAction,
  DOWNLOAD_SUBJECT_NOTE,
  DownloadSubjectNoteAction,
  GET_SUBJECT_NOTE,
  GET_SUBJECT_NOTES,
  GetSubjectNoteAction,
  GetSubjectNotesAction,
  TOGGLE_SUBJECT_NOTE_STATE,
  ToggleSubjectNoteStateAction,
  UPDATE_SUBJECT_NOTE,
  UpdateSubjectNoteAction,
  UPLOAD_SUBJECT_NOTE,
  UploadSubjectNoteAction,
} from "./actionTypes";
import {
  addSubjectNoteError,
  addSubjectNoteSuccess,
  deleteSubjectNoteError,
  deleteSubjectNoteSuccess,
  downloadNoteFileError,
  downloadNoteFileSuccess,
  getSubjectNoteError,
  getSubjectNoteSuccess,
  getSubjectNotesError,
  getSubjectNotesSuccess,
  toggleSubjectNoteStateError,
  toggleSubjectNoteStateSuccess,
  updateSubjectNoteError,
  updateSubjectNoteSuccess,
  uploadSubjectNoteError,
  uploadSubjectNoteSuccess,
} from "./actions";
import {
  addSubjectNote,
  deleteSubjectNote,
  downloadSubjectNote,
  getSubjectNote,
  getSubjectNotes,
  toggleSubjectNote,
  updateSubjectNote,
  uploadSubjectNote,
} from "../../helpers/backend_helper";

function* getSubjectNotesSaga({
  payload: { request, history },
}: GetSubjectNotesAction) {
  try {
    const response: ResponseGenerator = yield call(
      getSubjectNotes,
      request as PaginateQuery
    );
    yield put(getSubjectNotesSuccess(response.data));
  } catch (error) {
    yield put(getSubjectNotesError(error));
  }
}

function* getSubjectNoteSaga({
  payload: { id, history },
}: GetSubjectNoteAction) {
  try {
    const response: ResponseGenerator = yield call(getSubjectNote, id);
    yield put(getSubjectNoteSuccess(response.data));
  } catch (error) {
    yield put(getSubjectNoteError(error));
  }
}

function* addSubjectNoteSaga({
  payload: { request, history },
}: AddSubjectNoteAction) {
  try {
    yield call(addSubjectNote, request);
    yield put(addSubjectNoteSuccess());
  } catch (error) {
    yield put(addSubjectNoteError(error));
  }
}

function* updateSubjectNoteSaga({
  payload: { id, request, history },
}: UpdateSubjectNoteAction) {
  try {
    yield call(updateSubjectNote, id, request);
    yield put(updateSubjectNoteSuccess());
  } catch (error) {
    yield put(updateSubjectNoteError(error));
  }
}

function* deleteSubjectNoteSaga({
  payload: { id, history },
}: DeleteSubjectNoteAction) {
  try {
    yield call(deleteSubjectNote, id);
    yield put(deleteSubjectNoteSuccess());
  } catch (error) {
    yield put(deleteSubjectNoteError(error));
  }
}

function* toggleSubjectNoteStateSaga({
  payload: { id, history },
}: ToggleSubjectNoteStateAction) {
  try {
    yield call(toggleSubjectNote, id);
    yield put(toggleSubjectNoteStateSuccess(id));
  } catch (error) {
    yield put(toggleSubjectNoteStateError(error));
  }
}

function* uploadSubjectNoteSaga({
  payload: { file, id },
}: UploadSubjectNoteAction) {
  try {
    const response: ResponseGenerator = yield call(uploadSubjectNote, file, id);
    yield put(uploadSubjectNoteSuccess(response.data));
  } catch (error) {
    yield put(uploadSubjectNoteError(error));
  }
}

function* downloadSubjectNoteSaga({
  payload: { id },
}: DownloadSubjectNoteAction) {
  try {
    const response: ResponseGenerator = yield call(downloadSubjectNote, id);
    yield put(downloadNoteFileSuccess(response));
  } catch (error) {
    yield put(downloadNoteFileError(error));
  }
}

function* SubjectNoteSaga() {
  yield takeEvery(GET_SUBJECT_NOTES, getSubjectNotesSaga);
  yield takeEvery(GET_SUBJECT_NOTE, getSubjectNoteSaga);
  yield takeEvery(ADD_SUBJECT_NOTE, addSubjectNoteSaga);
  yield takeEvery(UPDATE_SUBJECT_NOTE, updateSubjectNoteSaga);
  yield takeEvery(DELETE_SUBJECT_NOTE, deleteSubjectNoteSaga);
  yield takeEvery(TOGGLE_SUBJECT_NOTE_STATE, toggleSubjectNoteStateSaga);
  yield takeEvery(UPLOAD_SUBJECT_NOTE, uploadSubjectNoteSaga);
  yield takeEvery(DOWNLOAD_SUBJECT_NOTE, downloadSubjectNoteSaga);
}

export default SubjectNoteSaga;
